__webpack_public_path__ = window.__webpack_public_path__

import '../scss/ffc.scss'
import smoothscroll from 'smoothscroll-polyfill';
import Theme from './critical'

smoothscroll.polyfill();

let theme = new Theme()
theme.mountComponents()

document.addEventListener('shopify:section:unload', e => {
  theme.unmountComponents(e.target)
})

document.addEventListener('shopify:section:load', e => {
  theme.mountComponents(e.target)
  theme._ctx.emit('ffc--lazy-load-update')
})
